export interface Game {
  id: string;
  title: string;
  description: string;
  category: string;
  imageUrl: string;
  rating: number;
  players: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
}

export const games: Game[] = [
  {
    id: 'game-001',
    title: '修仙模拟器',
    description: '沉浸式修仙体验，从凡人到仙帝的传奇之旅，丰富的剧情与战斗系统，让你感受真正的修仙世界。',
    category: 'role-playing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystical%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20golden%20clouds%2C%20warm%20amber%20lighting%2C%20ethereal%20atmosphere%2C%20cinematic%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-xiuxian&orientation=landscape',
    rating: 4.8,
    players: '128.5万',
    tags: ['角色扮演', '修仙', '热门'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-002',
    title: '星际指挥官',
    description: '指挥你的星际舰队，探索无尽宇宙，征服星系，建立属于你的太空帝国。',
    category: 'strategy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20space%20battle%20with%20massive%20starships%20and%20nebulae%2C%20warm%20cosmic%20lighting%2C%20cinematic%20sci-fi%20art%2C%20dramatic%20composition%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-scifi&orientation=landscape',
    rating: 4.7,
    players: '96.3万',
    tags: ['策略', '科幻', '热门'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-003',
    title: '幻境奇缘',
    description: '唯美仙侠世界，邂逅各路仙子，书写属于你的浪漫传奇故事。精美画面与动人剧情完美结合。',
    category: 'role-playing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20fantasy%20world%20with%20cherry%20blossoms%20and%20ancient%20palaces%2C%20warm%20golden%20sunset%20lighting%2C%20romantic%20atmosphere%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-fantasy&orientation=landscape',
    rating: 4.9,
    players: '156.8万',
    tags: ['角色扮演', '仙侠', '恋爱'],
    featured: true,
    isNew: true,
  },
  {
    id: 'game-004',
    title: '暗影忍者传',
    description: '成为一名忍者，掌握暗杀之术，在黑暗世界中完成各种危险任务，体验忍者生涯。',
    category: 'action',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20ninja%20warrior%20silhouette%20against%20crimson%20moon%2C%20Japanese%20castle%20rooftop%20scene%2C%20dramatic%20warm%20lighting%2C%20cinematic%20game%20art%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-ninja&orientation=landscape',
    rating: 4.6,
    players: '87.2万',
    tags: ['动作', '忍者', '格斗'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-005',
    title: '海岛大亨',
    description: '经营你的热带海岛度假村，建造设施，吸引游客，打造世界顶级的休闲天堂。',
    category: 'simulation',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tropical%20island%20resort%20with%20palm%20trees%20and%20turquoise%20water%2C%20warm%20sunlight%2C%20peaceful%20paradise%20atmosphere%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-island&orientation=landscape',
    rating: 4.5,
    players: '72.1万',
    tags: ['模拟经营', '休闲', '建造'],
    featured: false,
    isNew: true,
  },
  {
    id: 'game-006',
    title: '末日求生',
    description: '末日降临，丧尸横行，你必须在废土世界中寻找资源、建造庇护所、与其他幸存者合作求生。',
    category: 'action',
    imageUrl: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20wasteland%20with%20orange%20sky%20and%20ruined%20city%2C%20dramatic%20warm%20lighting%2C%20survival%20atmosphere%2C%20cinematic%20game%20art%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-survival&orientation=landscape',
    rating: 4.7,
    players: '112.4万',
    tags: ['动作', '生存', '射击'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-007',
    title: '魔幻学院',
    description: '进入魔法学院，学习各种法术，参加魔法对决，揭开学院隐藏的秘密。',
    category: 'role-playing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magical%20academy%20castle%20with%20floating%20candles%20and%20spell%20effects%2C%20warm%20golden%20lighting%2C%20mystical%20atmosphere%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-magic&orientation=landscape',
    rating: 4.4,
    players: '65.9万',
    tags: ['角色扮演', '魔法', '校园'],
    featured: false,
    isNew: true,
  },
  {
    id: 'game-008',
    title: '三国征战录',
    description: '重回三国时代，招募名将，排兵布阵，以智谋和勇气统一天下。',
    category: 'strategy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battlefield%20with%20warriors%20and%20banners%2C%20dramatic%20sunset%20lighting%2C%20epic%20war%20atmosphere%2C%20historical%20game%20art%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-threekingdom&orientation=landscape',
    rating: 4.8,
    players: '145.2万',
    tags: ['策略', '三国', '战争'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-009',
    title: '精灵宝可梦大冒险',
    description: '捕捉、训练各种可爱精灵，挑战道馆，成为最强的精灵训练大师。',
    category: 'role-playing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20fantasy%20creatures%20in%20a%20vibrant%20forest%20setting%2C%20warm%20sunlight%20through%20trees%2C%20adventure%20atmosphere%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-creature&orientation=landscape',
    rating: 4.9,
    players: '189.7万',
    tags: ['角色扮演', '冒险', '收集'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-010',
    title: '赛车狂飙',
    description: '顶级赛车体验，多种赛道与车型选择，感受极速狂飙的刺激。',
    category: 'sports',
    imageUrl: 'https://readdy.ai/api/search-image?query=High%20speed%20racing%20cars%20on%20a%20city%20track%20at%20sunset%2C%20motion%20blur%20effect%2C%20warm%20golden%20lighting%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-racing&orientation=landscape',
    rating: 4.3,
    players: '58.6万',
    tags: ['竞速', '体育', '赛车'],
    featured: false,
    isNew: false,
  },
  {
    id: 'game-011',
    title: '美食大亨',
    description: '从街边小摊到米其林餐厅，打造你的美食帝国，征服全球食客的味蕾。',
    category: 'simulation',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20restaurant%20kitchen%20with%20warm%20lighting%20and%20delicious%20dishes%2C%20culinary%20atmosphere%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-food&orientation=landscape',
    rating: 4.6,
    players: '78.3万',
    tags: ['模拟经营', '美食', '休闲'],
    featured: false,
    isNew: true,
  },
  {
    id: 'game-012',
    title: '江湖风云录',
    description: '踏入纷争不断的江湖世界，学习绝世武功，结交江湖豪杰，书写你的武林传奇。',
    category: 'role-playing',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20master%20on%20misty%20mountain%20peak%20at%20dawn%2C%20golden%20morning%20light%2C%20wuxia%20atmosphere%2C%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-martial&orientation=landscape',
    rating: 4.7,
    players: '103.5万',
    tags: ['角色扮演', '武侠', '江湖'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-013',
    title: '塔防英雄',
    description: '策略塔防经典，布置防御塔抵御敌人入侵，多种英雄和技能组合等你探索。',
    category: 'strategy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Medieval%20castle%20defense%20with%20archer%20towers%20and%20magical%20barriers%2C%20dramatic%20battle%20lighting%2C%20strategy%20game%20art%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-tower&orientation=landscape',
    rating: 4.5,
    players: '92.1万',
    tags: ['策略', '塔防', '休闲'],
    featured: false,
    isNew: false,
  },
  {
    id: 'game-014',
    title: '深海探秘',
    description: '潜入神秘深海，探索未知水域，发现珍贵宝藏，与海洋生物亲密互动。',
    category: 'adventure',
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20exploration%20with%20bioluminescent%20creatures%20and%20ancient%20ruins%2C%20mysterious%20blue-green%20underwater%20lighting%2C%20adventure%20game%20art%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-ocean&orientation=landscape',
    rating: 4.4,
    players: '45.3万',
    tags: ['冒险', '探索', '海洋'],
    featured: false,
    isNew: true,
  },
  {
    id: 'game-015',
    title: '拳皇格斗',
    description: '经典格斗游戏，众多角色任你选择，华丽的连招和必杀技，燃爆你的格斗之魂。',
    category: 'action',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20martial%20arts%20fight%20in%20an%20arena%20with%20spotlights%2C%20dramatic%20warm%20lighting%2C%20fighting%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-fighter&orientation=landscape',
    rating: 4.8,
    players: '134.6万',
    tags: ['动作', '格斗', '街机'],
    featured: true,
    isNew: false,
  },
  {
    id: 'game-016',
    title: '宠物庄园',
    description: '经营温馨的宠物庄园，收养可爱小动物，种植花草，享受悠闲的田园生活。',
    category: 'simulation',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20farm%20with%20adorable%20animals%20and%20colorful%20flowers%2C%20warm%20sunny%20day%20lighting%2C%20cozy%20casual%20game%20art%20style%2C%20no%20text%20or%20UI&width=600&height=400&seq=game-card-pet&orientation=landscape',
    rating: 4.6,
    players: '69.8万',
    tags: ['模拟经营', '宠物', '休闲'],
    featured: false,
    isNew: false,
  },
];